
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ifs-interview",
      function () {
        return require("private-next-pages/ifs-interview/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ifs-interview"])
      });
    }
  